import type { ComponentProps, HTMLProps } from 'react';
import type React from 'react';

import { useMergeRefs } from '@floating-ui/react';

import type { Box } from '@change-corgi/design-system-legacy/layout';
import { buttonResetStyles } from '@change-corgi/design-system-legacy/reset';

import { useTooltipContext } from '../hooks/context';

export const TooltipTrigger = (({ children, ref: propRef, ...props }) => {
	const context = useTooltipContext();
	const ref = useMergeRefs([context.refs.setReference, propRef]);

	return (
		<button
			type="button"
			ref={ref}
			sx={{
				...buttonResetStyles,
				lineHeight: 0,
				color: context.isSunriseEnabled ? 'sunrise.semantic.icon.strong' : 'neutral-grey700',
			}}
			{...context.getReferenceProps(props as HTMLProps<HTMLElement>)}
		>
			{children}
		</button>
	);
}) as React.FC<
	ComponentProps<typeof Box> & {
		ref?: React.RefObject<HTMLDivElement>;
	}
>;
